<template lang="pug">
  accordion-item.mail(@load="loadObject", :isLoading="isLoading", :initial-active='initialActive', :initial-stay-active='initialStayActive', :injected='injected', :classes='{onObject: hasLinkedObject , unread: hasUnreadMessages}', ref='accordionItem', @toggleActive="activeChange")

    //- ********************
    //- Conversation header
    //- ********************
    template(slot="header")
      vue-object-img(:object='lastSender')
      //- texts
      h4 {{ conversation.senders | users }}
        .text-muted &nbsp;({{ nbMessages }})
      h3 
        .badge.info(v-if='conversation.inCreation || newMessage') {{$t('conversations.draft.short')}}
        .badge.info(v-if="conversation.unreadMessages > 0") {{conversation.unreadMessages}}
        mark-text {{ conversation.title }}
        .text-muted(v-if='firstUnreadMessageOrLastReadMessage != ""') {{ firstUnreadMessageOrLastReadMessage }}
      .max600.text-muted {{ firstUnreadMessageOrLastReadMessage }}
      //- btns to archive / to inbox 
      .hoverbtns(v-if='!conversation.inCreation')
        i.fa.fa-archive(v-if='!conversation.archived', @mousedown.stop='', @click.stop='archive', :title='$t("conversations.titles.archive")')
        i.fa.fa-inbox(v-if='conversation.archived', @mousedown.stop='',@click.stop='toInbox', :title='$t("conversations.titles.toInbox")')

      //- Right menu when open
      .menu.doNotDesactiveOnClick.dropbox(v-if='!conversation.inCreation')
        .dropdown-toggle(data-toggle="dropdown")
          i.fa.fa-ellipsis-v
        ul.dropdown-menu.dropdown-menu-right
          li(@click='markAsUnread')
            a {{$t('conversations.menu.markAsUnread')}}
          li(@click='archive', v-if='!conversation.archived')
            a {{$t('conversations.menu.archive')}}
          li(@click='toInbox', v-if='conversation.archived')
            a {{$t('conversations.menu.toInbox')}}


      //- link if linked object
      template(v-if='hasLinkedObject')
        shared-object-abstract(:sharedObject='conversation.onObject', @click='openObjectPopup')
    //- ********************
    //- Conversation body
    //- ********************
    template(slot="body")

      //- participants
      .toDiv(v-if='!conversation.inCreation && conversation.participants.length > 0', @click='toggleNameInParticipants', role='button', :class="{showNames: showNameInParticipants}")
        .text {{$t('conversations.participants')}}
        ul
          li(v-for='participant in conversation.participants', :key='participant.id')
            vue-object-img(:object='participant', v-if='participant.kind != "email"') 
            i.fa.fa-envelope(v-else, :title='participant.name')
            template(v-if='showNameInParticipants') 
              | &nbsp; {{participant.name}} &nbsp;&nbsp;&nbsp;

      //- link if linked object
      template(v-if='hasLinkedObject && !injected')
        shared-object-abstract(:sharedObject='conversation.onObject', @click='openObjectPopup')

      //- messages
      template(v-for='(message, index) in messages')
        
        //- show circle to show hidden messages if any
        template(v-if='messageAtIndexIsHidden(index) && !hasPreviousHiddenMessage(index)')
          .hiddenMessages.doNotDesactiveOnClick(@click="showAllMessages")
            .clickToShow {{ nbHiddenMessagesAtIndex(index) }}
        //- each message
        message(:message='message', :reduced='messageIsReduced(index)', v-if='!messageAtIndexIsHidden(index)', :key="message.id")
      //- answer          
      .answerDiv.form-horizontal(v-if='answering')
        template(v-if='conversation.inCreation')
          input(v-model='conversation.title', type='text', :placeholder='$t("conversations.creation.objectPlaceholder")', ref="titleInput", v-validate="'required'", tabindex=1, name="title", :class="{'error': errors.has('title')}")
          .toMessage.doNotDesactiveOnClick(:class="{'error': errors.has('to')}")
            .clearfix(ref="toInput")
        .answer
          vue-object-img(:object='user')
          textarea-autosize(v-model='newMessage', @blur.native="blurTextarea($event)", ref="textarea", tabindex=3, :placeholder='$t("conversations.creation.messagePlaceholder")', name="newMessage" v-validate="'required'", :class="{'error': errors.has('newMessage')}")
          .buttons
            button.btn.btn-primary(type="button", @click='sendMessage')
              | {{$t("conversations.answerDiv.send")}}
            //- a.btn(type="button", @click='popupNotImplemented()')
            //-   i.fa.fa-paperclip
            a.pull-right.btn(type="button", @click='forgetMessage', v-if='conversation.inCreation || newMessage')
              i.fa.fa-trash
            small.pull-right(style="margin-top: 10px", v-if="newMessage")
              template(v-if="draftStatus == STATUS.SAVING") {{$t('conversations.draft.saving')}}
              template(v-if="draftStatus == STATUS.SAVED") {{$t('conversations.draft.success')}}
              template(v-if="draftStatus == STATUS.ERROR") {{$t('conversations.draft.error')}}
      .isWriting(v-if="isWriting") {{$t('conversations.isWriting')}}

      //- footer, if not answering
      .footer(v-if='!answering', @click='enableAnswer')
        vue-object-img(:object='user')
        template(v-if='nbMessages > 0') {{$t("conversations.answerDiv.footer.answer")}}
        template(v-if='nbMessages == 0') {{$t("conversations.answerDiv.footer.startConversation")}}
</template>
<script>
import STATUS from '@/utils/status'
import AccordionItem from '@/components/shared/Accordion/Accordion-Item'
import VueObjectImg from '@/components/shared/VueObjectImg'
import SharedObjectAbstract from '@/components/shared/SharedObjectAbstract'
import Vue from 'vue'

import Message from './Message'

import Taggle from 'taggle'
import MarkText from '@/components/shared/MarkText'

import {users} from '@/components/shared/vue.globals'
import api from '@/utils/api'
import {mapGetters} from 'vuex'

import modalsBus from '@/components/shared/ModalsBus'

import $ from 'jquery'
import _ from 'lodash'
import 'jquery-textcomplete'

import Noty, {success} from '@/components/shared/Notify'

export default {
  props: {
    conversation: {
      type: Object,
      required: true
    },
    initialActive: {
      default: false
    },
    initialStayActive: {
      default: false
    },
    injected: {
      default: false
    }
  },
  data () {
    return {
      answering: false,
      newMessage: '',
      hideReadMessages: true,
      showParticipants: false,
      showNameInParticipants: false,
      draftStatus: null,
      isWriting: false,
      STATUS
    }
  },
  components: {
    AccordionItem,
    VueObjectImg,
    Message,
    MarkText,
    SharedObjectAbstract
  },
  mounted () {
    this.setConversation()
    this.updateOnAppwire = (data) => {
      // console.log(data)
      if (data.action === 'newMessage' && data.cId === this.conversation.id && data.uId !== this.user.id) {
        if (this.conversation.refreshMessages) {
          return
        }
        this.conversation.refreshMessages = true
        api.get('/messages', {params: {
          convId: this.conversation.id,
          markAsRead: false
        }}).then((response) => {
          this.isWriting = false
          this.$set(this.conversation, 'messages', response.data.messages)
          this.$set(this.conversation, 'unreadMessages', response.data.unreadMessages)
          this.$set(this.conversation, 'participants', response.data.participants)
          this.conversation.refreshMessages = false
        }).catch(() => {
          this.conversation.refreshMessages = false
        })
      } else {
        if (data.action === 'writing' && data.cId === this.conversation.id && data.uId !== this.user.id) {
          this.isWriting = true
          if (this.timeoutWriting != null) {
            clearTimeout(this.timeoutWriting)
          }
          this.timeoutWriting = setTimeout(() => {
            this.isWriting = false
            this.timeoutWriting = null
          }, 5000)
        }
      }
    }
    this.$appwireEvents.$on('conversations', this.updateOnAppwire)
  },
  destroyed () {
    this.$appwireEvents.$off('conversations', this.updateOnAppwire)
  },
  computed: {
    ...mapGetters('user', [
      'user'
    ]),
    ...mapGetters('groops', [
      'groops'
    ]),
    ...mapGetters('search', [
      'searchText',
      'searchObject',
      'searchOpen'
    ]),
    accordionItem () { // needed for accordion
      return this.$refs.accordionItem
    },
    isLoading () {
      return (!this.conversation.messages || this.conversation.messages.length === 0) && this.conversation.id !== -1 && !this.conversation.inCreation
    },
    hasLinkedObject () {
      return !_.isNil(this.conversation.onObject)
    },
    hasUnreadMessages () {
      return this.conversation.unreadMessages > 0
    },
    lastSender () {
      return this.conversation.senders[this.conversation.senders.length - 1]
    },
    firstUnreadMessageOrLastReadMessage () {
      return this.newMessage || this.conversation.lastMessage
    },
    messages () {
      return this.conversation.messages || []
    },
    nbMessages () {
      return this.messages.length || this.conversation.nbMessages
    },
    nbUnreadMessages () {
      return this.conversation.unreadMessages
    },
    nbReadMessages () {
      return this.nbMessages - this.nbUnreadMessages
    }
  },
  methods: {
    setConversation () {
      this.answering = false
      this.newMessage = ''
      this.hideReadMessages = true
      this.showParticipants = false
      this.showNameInParticipants = false
      this.draftStatus = null
      if (!this.conversation.eternalId) {
        this.$set(this.conversation, 'eternalId', this.conversation.id)
      }
      if (this.conversation.draft) {
        this.newMessage = this.conversation.draft
        this.answering = true
        this.draftStatus = STATUS.SAVED
      }
      this.$watch('newMessage', _.debounce(() => {
        if (this.conversation.inCreation || this.conversation.id < 0) {
          return
        }
        this.draftStatus = STATUS.SAVING
        api.put('/conversation/' + this.conversation.id, {draft: this.newMessage}).then(() => {
          this.draftStatus = STATUS.SAVED
        }).catch(() => {
          this.draftStatus = STATUS.ERROR
        })
      }, 500))
    },
    toggleNameInParticipants () {
      this.showNameInParticipants = !this.showNameInParticipants
    },
    loadObject () {
      if (this.conversation.messages === undefined) {
        this.$set(this.conversation, 'messages', [])
        api.get('/messages', {params: {
          convId: this.conversation.id,
          markAsRead: true
        }}).then((response) => {
          this.$set(this.conversation, 'messages', response.data.messages)
          this.$set(this.conversation, 'participants', response.data.participants)
        })
      }
    },
    messageAtIndexIsHidden (index) {
      if (!this.hideReadMessages) {
        return false
      }
      for (let text of this.searchObject.texts) {
        if (this.messages[index].text.indexOf(text) > -1) {
          return false
        }
      }
      return index !== 0 && index <= this.nbMessages - this.nbUnreadMessages - 2
    },
    hasPreviousHiddenMessage (index) {
      return index !== 0 && this.nbHiddenMessagesAtIndex(index - 1)
    },
    nbHiddenMessagesAtIndex (index) {
      let nb = 0
      while (index <= this.nbMessages - this.nbUnreadMessages - 2) {
        if (!this.messageAtIndexIsHidden(index)) {
          return nb
        }
        nb++
        index++
      }
      return nb
    },
    messageIsReduced (index) {
      if (!(index < this.nbReadMessages && index !== this.nbMessages - 1)) {
        return false
      }
      for (let text of this.searchObject.texts) {
        if (this.messages[index].text.indexOf(text) > -1) {
          return false
        }
      }
      return true
    },
    activeChange (isActive) {
      if (!isActive) {
        this.hideReadMessages = true
        this.conversation.unreadMessages = 0
      } else {
        this.markAsRead()
        if (this.newMessage !== '') {
          this.enableAnswer()
        }
        if (this.conversation.inCreation) {
          this.goToFirstFieldToEdit()
          this.enableTags()
        }
      }
    },
    goToFirstFieldToEdit () {
      if (!this.$refs.accordionItem.active) {
        this.$refs.accordionItem.toggleActive()
      }
      this.answering = true
      this.$nextTick(() => {
        if (this.conversation.inCreation) {
          $(this.$refs.titleInput).focus()
        } else {
          this.enableAnswer()
        }
      })
    },
    archive () {
      this.$store.dispatch('conversations/archive', this.conversation).then(() => {
        success(this._i18n.t('conversations.notify.archived'))
        this.$synchronize.callASAP('conversationsUpdateCount')
      })
    },
    toInbox () {
      this.$store.dispatch('conversations/toInbox', this.conversation).then(() => {
        success(this._i18n.t('conversations.notify.toInbox'))
        this.$synchronize.callASAP('conversationsUpdateCount')
      })
    },
    markAsUnread () {
      if (this.$refs.accordionItem.active) {
        this.$refs.accordionItem.toggleActive()
      }
      let isAlreadyUnread = this.conversation.unreadMessages !== 0
      this.$nextTick(() => { // become not active => setUnreadMessages = 0 => need to wait active toggle ends
        this.conversation.unreadMessages = this.nbMessages
      })
      if (!isAlreadyUnread) {
        this.$store.dispatch('conversations/addMarkOneMoreAsUnread')
      }
      api.put('/conversation/' + this.conversation.id, {
        mark: 'unread'
      }).then(() => {
        this.$synchronize.callASAP('conversationsUpdateCount')
      })
    },
    markAsRead () {
      // this.conversation.unreadMessages = 0
      let isAlreadyRead = this.conversation.unreadMessages === 0
      if (!isAlreadyRead) {
        this.$store.dispatch('conversations/addMarkOneMoreAsRead')
      }
      api.put('/conversation/' + this.conversation.id, {
        mark: 'read'
      }).then(() => {
        this.$synchronize.callASAP('conversationsUpdateCount')
      })
    },
    showAllMessages () {
      this.hideReadMessages = false
    },
    enableAnswer (e) {
      if (e) {
        e.stopPropagation()
      }
      this.answering = true
      this.$nextTick(() => {
        $(this.$refs.textarea.$el).focus()
        // autosize(_this.$refs.textarea);
      })
    },
    forgetMessage () {
      if (this.conversation.inCreation) {
        if ((this.newMessage === '' && this.conversation.participants <= 1) || confirm(this.$i18n.t('conversations.draft.confDelete'))) {
          this.$store.dispatch('conversations/removeConversation', this.conversation)
        }
        return
      }
      this.newMessage = ''
      this.answering = false
    },
    sendMessage () {
      if (this.conversation.inCreation && this.conversation.participants.length === 0) {
        this.$validator.errors.add('to', 'Participants ?', 'to')
      }
      this.$validator.validateAll().then(success => {
        if (!success) {
          return
        }
        if (this.conversation.inCreation && this.conversation.participants.length === 0) {
          return
        }
        this.conversation.unreadMessages = 0
        let message = this.newMessage
        this.$store.dispatch('conversations/sendMessage', {
          conversation: this.conversation,
          message: message
        }).catch(() => {
          this.newMessage = message
          new Noty({
            text: Vue.i18n.t('globals.error'),
            type: 'error'
          }).show()
        }).then(() => {
          new Noty({
            text: Vue.i18n.t('conversations.notify.sendMessage.ok'),
            type: 'success'
          }).show()
        })
        this.newMessage = ''
        this.$nextTick(() => {
          this.$validator.reset()
        })
      })
    },
    blurTextarea () {
      if (this.conversation.inCreation) {
        return
      }
      if (this.newMessage === '' || _.isUndefined(this.newMessage)) {
        this.answering = false
      }
    },
    openObjectPopup ($event) {
      if ($event) {
        $event.stopPropagation()
      }
      if (this.conversation.onObject.kind !== 'deleted') {
        modalsBus.open(modalsBus.modals.OPEN_SHARED_OBJECT, this.conversation.onObject)
      }
    },
    enableTags () {
      return Vue.nextTick(() => {
        if (this.$refs.toInput.innerHTML !== '') {
          return
        }
        let searchParticipant = (kindAndId) => {
          let participants = this.conversation.participants
          return _.find(participants, (p) => p.kind + p.id === kindAndId)
        }
        let iconAndNameForElement = (element) => {
          let icon = ''
          if (element.kind === 'email') {
            icon = "<i class='fa fa-envelope'></i>&nbsp;"
          }
          if (element.kind === 'group') {
            let vm = new Vue({
              template: '<vue-object-img :object="group"></vue-object-img>',
              components: {
                VueObjectImg
              },
              data: {
                group: element
              }
            }).$mount()
            icon = vm.$el.outerHTML
          }
          if (element.kind === 'user') {
            let vm = new Vue({
              template: '<vue-object-img :object="user"></vue-object-img>',
              components: {
                VueObjectImg
              },
              data: {
                user: element
              }
            }).$mount()
            icon = vm.$el.outerHTML
          }
          return icon + _.escape(element.name)
        }
        let explodeGroup = (group) => {
          taggle.remove(group.kind + group.id)
          api.get('/group/' + group.id + '/members').then((response) => {
            let participants = this.conversation.participants
            _.forEach(response.data.members, (m) => {
              if (_.findIndex(participants, m) === -1 && m.id !== this.user.id) {
                participants.push(m)
                taggle.add(m.kind + m.id)
              }
            })
          })
        }
        let placeholder = this._i18n.t('conversations.creation.participantsPlaceholder')
        const taggle = new Taggle(this.$refs.toInput, {
          placeholder: placeholder,
          tabIndex: 2,
          submitKeys: [-1], // no submit key
          duplicateTagClass: 'bounce',
          tags: _.map(this.conversation.participants, (p) => p.kind + p.id),
          preserveCase: true,
          onBeforeTagRemove: (event, tag) => {
            if (event) {
              event.doNotDesactiveOnClick = true
            }
            let object = searchParticipant(tag)
            const i = _.findIndex(this.conversation.participants, (e) => e === object)
            if (i > -1) {
              this.conversation.participants.splice(i, 1)
            }
            return true
          },
          tagFormatter: (li) => {
            let innerItem = li.getElementsByClassName('taggle_text')[0]
            let object = searchParticipant(innerItem.innerText)
            innerItem.innerHTML = iconAndNameForElement(object)
            if (object.kind === 'group') {
              $(innerItem).append($('<i class="explodeGroup doNotDesactiveOnClick fa fa-th"></i>').on('click', (event) => {
                explodeGroup(object)
              }))
            }
            return li
          }
        }
        )

        // fix ajusting width problem
        let oldInputWith = taggle._setInputWidth
        taggle._setInputWidth = function (width) {
          if (!width) {
            oldInputWith.call(this, width)
          } else {
            oldInputWith.call(this, width - 30)
          }
        }
        const input = taggle.getInput()
        let contacts = []
        api.get('/contacts').then(response => {
          contacts = response.data.contacts
          // console.log(contacts)
        })
        return $(input).textcomplete([{
          match: /^(.+)$/,
          search: (term, callback) => {
            const foundGroups = $.map(this.groops, function (group) {
              if (group.name.toLocaleLowerCase().indexOf(term.toLocaleLowerCase()) >= 0) { return group } else { return null }
            })
            const foundContacts = $.map(contacts, function (contact) {
              if (contact.name.toLocaleLowerCase().indexOf(term.toLocaleLowerCase()) >= 0) { return contact } else { return null }
            })
            const found = foundGroups.concat(foundContacts)
            if (/\S+@\S+\.\S+/.test(term)) {
              found.push({kind: 'email', id: term, name: term})
            }
            return callback(found)
          },
          index: 1,
          template (element) {
            let icon = ''
            if (element.kind === 'email') {
              icon = "<i class='fa fa-envelope'></i>&nbsp;"
            }
            if (element.kind === 'group') {
              let vm = new Vue({
                template: '<vue-object-img :object="group"></vue-object-img>',
                components: {
                  VueObjectImg
                },
                data: {
                  group: element
                }
              }).$mount()
              icon = vm.$el.outerHTML
            }
            if (element.kind === 'user') {
              let vm = new Vue({
                template: '<vue-object-img :object="user"></vue-object-img>',
                components: {
                  VueObjectImg
                },
                data: {
                  user: element
                }
              }).$mount()
              icon = vm.$el.outerHTML
            }
            return icon + _.escape(element.name)
          },
          replace: (element, event) => {
            let captureMouseUp = (event) => {
              event.stopPropagation()
              window.removeEventListener('mouseup', captureMouseUp, true)
            }
            window.addEventListener('mouseup', captureMouseUp, true)
            let captureClick = (event) => {
              event.stopPropagation()
              window.removeEventListener('click', captureClick, true)
            }
            window.addEventListener('click', captureClick, true)
            if (this.conversation.participants.indexOf(element) === -1) {
              this.conversation.participants.push(element)
            }
            taggle.add(element.kind + element.id)
            return ''
          },
          noResultsMessage: 'Entrez une adresse email valide'
        }], {
          appendTo: '#body',
          dropdownClassName: 'dropdown-menu textcomplete-dropdown doNotDesactiveOnClick'
        })
      })
    }
  },
  filters: {
    users
  },
  watch: {
    newMessage () {
      this.$refs.accordionItem.updateLayout()
    },
    hideReadMessages () {
      this.$refs.accordionItem.updateLayout()
    },
    conversation () {
      this.setConversation()
    }
  }
}
</script>



// WEBPACK FOOTER //
// Conversation.vue?c9e7313a